import { render } from "./BlankLayout.vue?vue&type=template&id=42eda70a"
import script from "./BlankLayout.vue?vue&type=script&lang=js"
export * from "./BlankLayout.vue?vue&type=script&lang=js"

import "./BlankLayout.vue?vue&type=style&index=0&id=42eda70a&lang=scss"
script.render = render

export default script